'use strict'

module.exports = class ImageResize {

	constructor(config) {
		this.scale = 1
		this.dx = 0
		this.dy = 0

		this.canvas = document.createElement('canvas')
		this.canvas.width = config.width
		this.canvas.height = config.height
		this.canvas.style.left = Math.floor(config.padding / 2) + 'px'
		this.canvas.style.top = Math.floor(config.padding / 2) + 'px'

		this.canvas2 = document.createElement('canvas')
		this.canvas2.className = 'bgcanvas'
		this.canvas2.width = config.width + config.padding
		this.canvas2.height = config.height + config.padding

		this.ctx = this.canvas.getContext('2d')
		this.ctx2 = this.canvas2.getContext('2d')

		this.catchZoom()
		this.catchDrag()
	}

	setWrapper(wrapper) {
		wrapper.appendChild(this.canvas2)
		wrapper.appendChild(this.canvas)
	}

	setFile(file) {
		let reader = new FileReader()
		reader.addEventListener('load', () => {
			this.setFileType(file.type)
			this.addImg(reader.result)
		}, false)
		if (file) { reader.readAsDataURL(file) }
	}

	setFileType(type) {
		const uncompressed = [
			'image/png'
		]

		if (uncompressed.indexOf(type) !== -1) {
			this.fileType = 'image/png'
		} else {
			this.fileType = 'image/jpeg'
		}
	}

	addImg(src) {
		this.img = new Image()
		this.img.src = src
		this.img.onload = () => {
			this.setInitScale()
			this.draw()
		}
	}

	setInitScale() {
		let ws = this.canvas.width / this.img.width
		let hs = this.canvas.height / this.img.height
		if (ws > hs) {
			this.scale = ws
			this.dx = this.canvas.width / 2
			this.dy = (this.canvas.height / 2) +
				(this.canvas.height - (this.img.height * ws)) / -2
		}
		else {
			this.scale = hs
			this.dx = (this.canvas.width / 2) +
				(this.canvas.width - (this.img.width * hs)) / -2
			this.dy = this.canvas.height / 2
		}
	}

	done(cb) {
		// let img = this.canvas.toDataURL('data/png')
		// window.open(img)
		this.bgWhite(this.canvas)
		this.canvas.toBlob((blob) => {
			if (typeof cb === 'function') {
				cb(blob)
			}
		}, this.fileType, .8)
	}

	draw() {

		this.checkMinScale()
		this.checkPosition()

		let w = this.img.width * this.scale
		let h = this.img.height * this.scale

		this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
		this.ctx.drawImage(
			this.img,
			this.dx - (w/2),
			this.dy - (h/2),
			w, h
		)

		this.ctx2.clearRect(0, 0, this.canvas2.width, this.canvas2.height)
		this.ctx2.drawImage(
			this.img,
			this.dx + parseInt(this.canvas.style.left) - (w/2),
			this.dy + parseInt(this.canvas.style.top) - (h/2),
			w, h
		)
	}

	checkMinScale() {
		let ws = this.canvas.width / this.img.width
		let hs = this.canvas.height / this.img.height
		if (ws < hs) {
			let min = this.canvas.width / this.img.width
			if (this.scale < min) {
				this.scale = min
			}
		} else {
			let min = this.canvas.height / this.img.height
			if (this.scale < min) {
				this.scale = min
			}
		}
	}

	checkPosition() {

		let w = this.img.width * this.scale
		let h = this.img.height * this.scale

		if (this.dx > (w / 2)) { this.dx = w/2 }
		if (this.dy > (h / 2)) { this.dy = h/2 }

		if (this.dx < this.canvas.width - (w / 2)) {
			this.dx = this.canvas.width - (w / 2)
			if (this.canvas.width > w) {
				this.dx -= ((this.canvas.width - w) / 2)
			}
		}
		if (this.dy < this.canvas.height - (h / 2)) {
			this.dy = this.canvas.height - (h / 2)
			if (this.canvas.height > h) {
				this.dy -= ((this.canvas.height - h) / 2)
			}
		}


	}

	catchZoom() {
		this.canvas.onmousewheel = e => {
			e.preventDefault()
			if (e.wheelDelta > 0) { this.scale = this.scale * 1.02 }
			else { this.scale = this.scale / 1.02 }
			this.draw()
		}
	}

	catchDrag() {

		this.dragState

		this.canvas.onmousedown = e => {
			this.dragState = {
				x: e.clientX,
				y: e.clientY,
			}
			e.stopPropagation()
			return false
		}

		document.getElementsByTagName("BODY")[0].onmouseup = e => {
			this.dragState = null
			e.stopPropagation()
			return false
		}

		document.getElementsByTagName("BODY")[0].onmouseleave = e => {
			this.dragState = null
			e.stopPropagation()
			return false
		}

		document.getElementsByTagName("BODY")[0].onmousemove = e => {
			if (!this.dragState) { return }
			this.moveImg(e.clientX, e.clientY)
			e.stopPropagation()
			return false
		}

	}

	moveImg(x, y) {
		this.dx -= this.dragState.x - x
		this.dy -= this.dragState.y - y
		this.dragState.x = x
		this.dragState.y = y
		this.draw()
	}

	bgWhite(canvas) {
		const ctx = canvas.getContext('2d')
		const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height)
		const data = imgData.data
		for (let i = 0; i < data.length; i+=4) {
			if (data[i+3] < 255) {
				data[i] = 255
				data[i+1] = 255
				data[i+2] = 255
				data[i+3] = 255
			}
		}
		ctx.putImageData(imgData, 0, 0)
	}

}



//////////////////
// WEBPACK FOOTER
// ./src/helpers/image-resize.js
// module id = 5
// module chunks = 0